import { GENERATE_POSTS_GUEST } from "../configs/routes.js";
import api from "./api.js";

export const generatePostsGuest = (payload) =>
    new Promise((resolve, reject) => {
        api
            .post(GENERATE_POSTS_GUEST, payload, {
                timeout: 120000,
            })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });
